module.exports = __webpack_public_path__ + "img/9.01b50844.jpg";